const isFileSizeValid = (fileSizeLimit: number, files: File[]): boolean =>
  files.every((file) => file.size <= fileSizeLimit);

export default isFileSizeValid;
